<template>
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Nom de l'appareil</th>
                    <th>Numéro de série</th>
                    <th>Adresse MAC</th>
                    <th>Version du système</th>
                    <th>Fabricant</th>
                    <th @click="changeOrder('affectation')"><span class="order-by">Affectation<i class="material-icons">{{ getIcon('last_audit') }}</i></span></th>
                    <th>Temporaire/Permanent</th>
                    <th @click="changeOrder('last_audit')"><span class="order-by">Dernière actualisation&nbsp;<i class="material-icons">{{ getIcon('last_audit') }}</i></span></th>
                    <th @click="changeOrder('overall_score')"><span class="order-by">Score Global&nbsp;<i class="material-icons">{{ getIcon('overall_score') }}</i></span></th>
                    <th v-if="toggleScore">Score GPU</th>
                    <th v-if="toggleScore">Score CPU</th>
                    <th v-if="toggleScore">Score Mémoire</th>
                    <th v-if="toggleScore">Score Stockage</th>
                </tr>
            </thead>
    
            <tbody>
                <tr v-for="computer in props.computers"
                    class="expand"
                    title="Cliquer pour ouvrir les détails"
                    @click="emits('selectedComputer', computer)"
                >
                    <td>{{ computer.id }}</td>
                    <td>{{ computer.pc_name }}</td>
                    <td>{{ computer.serial_number }}</td>
                    <td>{{ computer.mac_address }}</td>
                    <td>{{ computer.os_version }}</td>
                    <td>{{ computer.manufacturer }}</td>
                    <td>{{ computer.current_affectation }}</td>
                    <td>
                        <template v-if="computer.current_affectation != 'En stock'">
                            <template v-if="computer?.affectation_is_permanent">
                                Permanent
                            </template>
                            <template v-else>
                                <p style="color: red; font-weight: bold;">Temporaire</p>
                            </template>
                        </template>
                    </td>
                    <td>{{ new Date(computer.last_audit).toLocaleString('fr-FR') }}</td>
                    <td :title="'Score GPU : ' + computer.latest_benchmark?.gpu_score + ' | Score CPU : ' + computer.latest_benchmark?.cpu_score + ' | Score Mémoire : ' + computer.latest_benchmark?.memory_score + ' | Score Stockage : ' + computer.latest_benchmark?.storage_score">{{ computer.latest_benchmark?.overall_score || 'N/A' }}</td>
                    <td v-if="toggleScore">{{ computer.latest_benchmark?.gpu_score || 'N/A' }}</td>
                    <td v-if="toggleScore">{{ computer.latest_benchmark?.cpu_score || 'N/A' }}</td>
                    <td v-if="toggleScore">{{ computer.latest_benchmark?.memory_score || 'N/A' }}</td>
                    <td v-if="toggleScore">{{ computer.latest_benchmark?.storage_score || 'N/A' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
const props = defineProps({
    computers: Object,
    toggleScore: Boolean,
    order: Object
})

const emits = defineEmits(['selectedComputer', 'updateOrder'])

const changeOrder = (field) => {
    const current = props.order[field] ?? null
    
    let next = null

    if (current === null)       next = 'asc'
    else if (current === 'asc') next = 'desc'
    else                        next = null

    emits('updateOrder', { field, direction: next })
}

const getIcon = (field) => {
    const value = props.order[field]

    if (value === null)  return 'unfold_more'
    if (value === 'asc') return 'arrow_drop_up'
    else                 return 'arrow_drop_down'
}
</script>

<style lang="scss" scoped>
.expand {
    cursor: pointer;

    i{
        display: flex;
    }
}

.table-container {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}

table {
    white-space: nowrap;
    overflow-x: scroll;
}

table thead {
    -webkit-user-select: none; /* Chrome, Safari */
    -moz-user-select: none;    /* Firefox */
    -ms-user-select: none;     /* Old Edge */
    user-select: none;

    th {
        padding: 1rem;
    }
}


table tr:nth-child(even) {
    background-color: $ciel-blue;
}

table tbody tr:hover {
    background-color: $pale-orange;

    cursor: pointer;
}

table td:hover {
    i {
        color: $orange;
    }
}

.toggle {
    cursor: pointer;
    
    align-items: center;
    
    width: 24px;
    height: 24px;

    &:hover {
        color: $orange;
    }
}

.score-header {
    display: flex;

    justify-content: center;
    align-items: center;
}

.order-by {
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        cursor: pointer;
    
        i {
            color: $orange;
        }
    }
}
</style>